import {
  TextField,
  ReferenceField,
  DateField,
  List,
  Datagrid,
  ReferenceInput,
  SelectInput,
} from "react-admin";

export const UserBookList = (props : any) => {
  const filters = [
    <ReferenceInput source="book"
      reference="bookss"
      label="Book"
      >
      <SelectInput optionText="title"/>
    </ReferenceInput>,
    <ReferenceInput source="user"
                    reference="users"
                    label="User"
    >
      <SelectInput optionText="name"/>
    </ReferenceInput>
  ];

  return (
    <List {...props} filters={filters}>
      <Datagrid>
        <ReferenceField
          source="book"
          reference="books"
          label="Book"
        >
          <TextField source="title"/>
        </ReferenceField>
        <ReferenceField
          source="user"
          reference="users"
          label="User"
        >
          <TextField source="name"/>
        </ReferenceField>
      </Datagrid>
    </List>
  );
};

export default UserBookList;
